import NextImage, { ImageProps } from 'next/image'

/**
 *
 * @description A wrapper for Next.js's Image component.
 * @param {ImageProps} props
 */
const Image = ({ ...props }: ImageProps) => <NextImage {...props} />

export default Image
